import { RootState } from '@app/redux/root-reducer';

export const selectAddAssetState = (store: RootState) => store.assetsReducer.addAsset;
export const selectAssetState = (store: RootState) => store.assetsReducer.assets;
export const selectDeleteAssetState = (store: RootState) => store.assetsReducer.deleteAsset;
export const selectUpdateAssetState = (store: RootState) => store.assetsReducer.updateAsset;
export const selectAddVendorState = (store: RootState) => store.assetsReducer.addVendor;
export const selectVendorsState = (store: RootState) => store.assetsReducer.vendors;
export const selectAddRepairAssests = (store: RootState) => store.assetsReducer.addRepairAssets;
export const selectAssetDetailsState = (store: RootState) => store.assetsReducer.assetDetails;
